import { PageRef } from 'providers/page-ref';

export type LoginPageParams = {
  mode?: 'login' | 'register' | 'otl-failed' | 'otl-sent' | 'landing' | 'subscription-success';
  email?: string;
  autoSendLink?: boolean;
  // when mode === 'subscription-success', these carry through to the cs-store-badges row
  androidInstallUrl?: string;
  iosInstallUrl?: string;
};

export const ILoginPage: PageRef<LoginPageParams, void> = {
  pageName: 'LoginPage',
} as PageRef<LoginPageParams, void>;
